<template lang="pug">
div
  Header(apiname='order',headname='SWANオーダー編集')
</template>

<script>
import Header from '@/views/components/swan/common/SubHeader'

export default {
  name: 'OrderTop',
  data () {
    return {
      result: ''
    }
  },
  created () {
  },
  components: {
    Header
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/components/swan/order/list.vue